import * as Yup from 'yup';

export const ShortlistAddCandidatesFormValidationSchema = Yup.object().shape({
  Name: Yup.object()
    .nullable()
    .required('This field is required')
    .test(
      'max-length',
      'You have exceeded the maximum number of 50 characters',
      value =>
        value
          ? value.label && value.__isNew__
            ? value.label.length <= 50
            : true
          : false
    ),

  Description: Yup.string().max(
    2000,
    'You have exceeded the maximum number of 2000 characters'
  ),
});
